import { render, staticRenderFns } from "./CardFunView.vue?vue&type=template&id=b8218808&scoped=true"
import script from "./CardFunView.vue?vue&type=script&lang=js"
export * from "./CardFunView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8218808",
  null
  
)

export default component.exports